// extracted by mini-css-extract-plugin
export default {"approval-status-approved":"AX3wd","approval-status-pending":"ITaOT","approval-status-pending-cert":"s6m72"};